import React from 'react'
import './accept.styles.scss'
import Worker from './worker'
import Loading from '../../../../components/loading/loading.component'
import Dialog from '../../../../components/dialog/dialog.component'
import { withRouter } from 'react-router-dom'

class AcceptDialog extends React.Component {

    constructor(props) {
        super(props)
        this.worker = Worker(this)
        this.state = this.worker.getDefaultState()
    }

    componentDidMount(){
        this.worker.acceptManuscript()
    }

    render() {
        return (
            <Dialog>
                <div className="accept card">
                    <div className="header">
                        <h4>Accept Manuscript</h4>
                    </div>
                    <div className={"flag " + this.state.flag.type}>
                        {this.state.flag.text}
                    </div>
                    {this.state.creating ? <Loading /> : <></>}
                </div>
            </Dialog>
        )
    }
}

export default withRouter(AcceptDialog)